// This file is auto-generated. Do not edit!

export default [
  {
    bpt: "0x0244B0025264dC5f5c113d472D579C9c994A59CE",
    id: "0x0244b0025264dc5f5c113d472d579c9c994a59ce0002000000000000000000c9",
    name: "BPT-OPARA",
    type: "Weighted",
    gauge: "0x390E36102245EAc08E5b3D4527b30B3A645F16d7",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000042",
        symbol: "OP",
      },
      {
        address: "0xd3594E879B358F430E20F82bea61e83562d49D48",
        symbol: "PSP",
      },
    ],
  },
  {
    bpt: "0x11f0b5CCA01B0F0A9Fe6265aD6E8ee3419c68440",
    id: "0x11f0b5cca01b0f0a9fe6265ad6e8ee3419c684400002000000000000000000d4",
    name: "BPT-BREV",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0xd3594E879B358F430E20F82bea61e83562d49D48",
        symbol: "PSP",
      },
    ],
  },
  {
    bpt: "0x2F6B6973F38381Fe453EA819b7e0f0897AdeAae7",
    id: "0x2f6b6973f38381fe453ea819b7e0f0897adeaae7000200000000000000000113",
    name: "80AURA-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x1509706a6c66CA549ff0cB464de88231DDBe213B",
        symbol: "AURA",
      },
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x39965c9dAb5448482Cf7e002F583c812Ceb53046",
    id: "0x39965c9dab5448482cf7e002f583c812ceb53046000100000000000000000003",
    name: "BPT-ROAD",
    type: "Weighted",
    gauge: "0x92F714Ae8C2150b7a7a75c6C97656BD4B348ca9E",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x4200000000000000000000000000000000000042",
        symbol: "OP",
      },
      {
        address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x3dC09DB8E571Da76Dd04E9176afc7fEEe0b89106",
    id: "0x3dc09db8e571da76dd04e9176afc7feee0b89106000000000000000000000019",
    name: "BPT-FRAX-MAI",
    type: "Stable",
    gauge: "0x4edA46C9921c8e928E559F3F0B5b9D3eC3DF8Ae9",
    tokens: [
      {
        address: "0x2E3D870790dC77A83DD1d18184Acc7439A53f475",
        symbol: "FRAX",
      },
      {
        address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
        symbol: "USDC",
      },
      {
        address: "0xdFA46478F9e5EA86d57387849598dbFB2e964b02",
        symbol: "MAI",
      },
    ],
  },
  {
    bpt: "0x4Dde571Dc66217a062e4B50f9b20c4D08b3245a0",
    id: "0x4dde571dc66217a062e4b50f9b20c4d08b3245a0000200000000000000000118",
    name: "VW8020",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x6D2E5b8841a6Aa5f0f973436357f75D3Eeb93312",
        symbol: "VMEX",
      },
    ],
  },
  {
    bpt: "0x587c2Ac5303D22E09cFFF5F3E75c7a46f802f566",
    id: "0x587c2ac5303d22e09cfff5f3e75c7a46f802f56600020000000000000000016f",
    name: "ECLP-USDC.e-USDC",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
        symbol: "USDC",
      },
      {
        address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x5BB3E58887264B667f915130fD04bbB56116C278",
    id: "0x5bb3e58887264b667f915130fd04bbb56116c27800020000000000000000012a",
    name: "50WETH-50OLAS",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0xFC2E6e6BCbd49ccf3A5f029c79984372DcBFE527",
        symbol: "OLAS",
      },
    ],
  },
  {
    bpt: "0x731290da2FA9970304E270940a91F3244B4637c9",
    id: "0x731290da2fa9970304e270940a91f3244b4637c900020000000000000000016e",
    name: "99USDC/1USDT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
        symbol: "USDC",
      },
      {
        address: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58",
        symbol: "USDT",
      },
    ],
  },
  {
    bpt: "0x7Ca75bdEa9dEde97F8B13C6641B768650CB83782",
    id: "0x7ca75bdea9dede97f8b13c6641b768650cb837820002000000000000000000d5",
    name: "ECLP-wstETH-WETH",
    type: "GyroE",
    gauge: "0x9F9f8d58496691D541C40dbc2b1b20f8C43e8d8C",
    tokens: [
      {
        address: "0x1F32b1c2345538c0c6f582fCB022739c4A194Ebb",
        symbol: "wstETH",
      },
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x7Ef99013E446dDCe2486b8E04735b7019a115e6F",
    id: "0x7ef99013e446ddce2486b8e04735b7019a115e6f000100000000000000000005",
    name: "BPT-8TRACK",
    type: "Weighted",
    gauge: "0xCf69061C06e57AE8f284e6d2EE0E889BD671Ab10",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000042",
        symbol: "OP",
      },
      {
        address: "0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb",
        symbol: "LYRA",
      },
      {
        address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
        symbol: "USDC",
      },
      {
        address: "0x8700dAec35aF8Ff88c16BdF0418774CB3D7599B4",
        symbol: "SNX",
      },
      {
        address: "0x8c6f28f2F1A3C87F0f938b96d27520d9751ec8d9",
        symbol: "sUSD",
      },
      {
        address: "0x97513e975a7fA9072c72C92d8000B0dB90b163c5",
        symbol: "BEETS",
      },
      {
        address: "0x9e1028F5F1D5eDE59748FFceE5532509976840E0",
        symbol: "PERP",
      },
      {
        address: "0xFE8B128bA8C78aabC59d4c64cEE7fF28e9379921",
        symbol: "BAL",
      },
    ],
  },
  {
    bpt: "0x8BB826Afc0fF7d2c034a2883F4C461ffD238E1C3",
    id: "0x8bb826afc0ff7d2c034a2883f4c461ffd238e1c300020000000000000000012b",
    name: "RSB",
    type: "GyroE",
    gauge: "0x6EF729bd61dca1B9B52745db37d43503ae0916f9",
    tokens: [
      {
        address: "0x035c93db04E5aAea54E6cd0261C492a3e0638b37",
        symbol: "stataOptUSDT",
      },
      {
        address: "0x4DD03dfD36548C840B563745e3FBeC320F37BA7e",
        symbol: "stataOptUSDCn",
      },
    ],
  },
  {
    bpt: "0x8CE93cF0AC66F2A22a19A9aC2631D83068481469",
    id: "0x8ce93cf0ac66f2a22a19a9ac2631d83068481469000200000000000000000170",
    name: "ECLP-USDT0-USDT",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x01bFF41798a0BcF287b996046Ca68b395DbC1071",
        symbol: "USD₮0",
      },
      {
        address: "0x94b008aA00579c1307B0EF2c499aD98a8ce58e58",
        symbol: "USDT",
      },
    ],
  },
  {
    bpt: "0x9620b74077e2A9f118cD37ef60001Aeb327EC1a7",
    id: "0x9620b74077e2a9f118cd37ef60001aeb327ec1a7000200000000000000000171",
    name: "20WETH/80VLR",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0x4e107a0000DB66f0E9Fd2039288Bf811dD1f9c74",
        symbol: "VLR",
      },
    ],
  },
  {
    bpt: "0x9FF36E48edbF6cb910Ebf9ef70f6Aeba41391fCE",
    id: "0x9ff36e48edbf6cb910ebf9ef70f6aeba41391fce00020000000000000000016d",
    name: "ECLP-WETH-USDC-dyn",
    type: "GyroE",
    gauge: "0x0e5973d6Bd0938216452E3a5502Fa331b7Ad63F7",
    tokens: [
      {
        address: "0x0b2C639c533813f4Aa9D7837CAf62653d097Ff85",
        symbol: "USDC",
      },
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xD13D81aF624956327A24d0275CBe54b0eE0E9070",
    id: "0xd13d81af624956327a24d0275cbe54b0ee0e9070000200000000000000000109",
    name: "80OATHv2-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x00e1724885473B63bCE08a9f0a52F35b0979e35A",
        symbol: "OATH",
      },
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xd6E5824b54f64CE6f1161210bc17eeBfFC77E031",
    id: "0xd6e5824b54f64ce6f1161210bc17eebffc77e031000100000000000000000006",
    name: "BPT-LOVE",
    type: "Weighted",
    gauge: "0x7b561BacfC637319685fa9a2EffA562625815e2f",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000042",
        symbol: "OP",
      },
      {
        address: "0x97513e975a7fA9072c72C92d8000B0dB90b163c5",
        symbol: "BEETS",
      },
      {
        address: "0xFE8B128bA8C78aabC59d4c64cEE7fF28e9379921",
        symbol: "BAL",
      },
    ],
  },
  {
    bpt: "0xeFb0D9F51EFd52d7589A9083A6d0CA4de416c249",
    id: "0xefb0d9f51efd52d7589a9083a6d0ca4de416c24900020000000000000000002c",
    name: "BPT-IBETH",
    type: "Weighted",
    gauge: "0x3672884a609bFBb008ad9252A544F52dF6451A03",
    tokens: [
      {
        address: "0x00a35FD824c717879BF370E70AC6868b95870Dfb",
        symbol: "IB",
      },
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xf3420D479d8DAa6ced1d48097Aad67eF38A1Fe1c",
    id: "0xf3420d479d8daa6ced1d48097aad67ef38a1fe1c0001000000000000000000c0",
    name: "BPT-GTRAIN",
    type: "Weighted",
    gauge: "0x5Cb64e0011365c1C771631C3cAA7F08bc39E691B",
    tokens: [
      {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
      },
      {
        address: "0xc5b001DC33727F8F26880B184090D3E252470D45",
        symbol: "ERN",
      },
      {
        address: "0xfD389Dc9533717239856190F42475d3f263a270d",
        symbol: "GRAIN",
      },
    ],
  },
] as const
